import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Opened } from '../../../components/Tickets';
import {
  fetchUserInfo,
  fetchTicketsOpened,
  fetchTicketDetails,
  addTicketMessage,
  createTicket,
  closeTicket,
} from '../../../actions';

const mapStateToProps = (state) => ({
  user: state.user.payload,
  pageLoading: state.user.pageLoading,
  loading: state.tickets.loading,
  messageLoading: state.tickets.messageLoading,
  ticketsOpened: state.tickets.ticketsOpened,
  ticketDetails: state.tickets.ticketDetails,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchUserInfo,
      fetchTicketsOpened,
      fetchTicketDetails,
      addTicketMessage,
      createTicket,
      closeTicket,
    },
    dispatch
  );


export default connect(mapStateToProps, mapDispatchToProps)(Opened);
